"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importDefault(require("react"));

var react_select_1 = require("react-select");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var custom_icon_1 = require("./custom-icon");

var OptionWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 0 0.5rem 0.5rem 0.5rem;\n  &:first-child {\n    padding-top: 0.5rem;\n  }\n\n  ", "\n\n  > div {\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n\n    &:active {\n      background-color: ", ";\n    }\n  }\n"], ["\n  padding: 0 0.5rem 0.5rem 0.5rem;\n  &:first-child {\n    padding-top: 0.5rem;\n  }\n\n  ", "\n\n  > div {\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n\n    &:active {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
  var optionColor = _a.optionColor,
      theme = _a.theme;
  return optionColor && "color: ".concat((0, ui_helper_deep_branding_1.getFromTheme)(optionColor, theme), ";");
}, function (_a) {
  var theme = _a.theme,
      isSelected = _a.isSelected,
      isFocused = _a.isFocused;
  return isFocused ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["300"]', theme) : isSelected ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["300"]', theme) : 'transparent';
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["300"]', theme);
});

function Option(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement(OptionWrapper, {
    isFocused: props.isFocused,
    isSelected: props.isSelected,
    optionColor: props.data.optionColor,
    "data-testid": "deprecated-select-option"
  }, react_1.default.createElement(react_select_1.components.Option, tslib_1.__assign({}, props), props.data.customIcon && react_1.default.createElement(custom_icon_1.CustomIcon, {
    iconSrc: props.data.customIcon
  }), !props.data.customIcon && props.data.icon && react_1.default.createElement(ui_icon_1.Icon, {
    name: props.data.icon,
    color: props.data.iconColor || 'grey-500',
    mr: 1
  }), children));
}

exports.Option = Option;
var templateObject_1;